import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';

import Layout from './Layout';

import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Board from "./pages/Board";
import Blogs from "./pages/Blogs";
import PhotoGallery from "./pages/PhotoGallery";

import PastEvents from "./pages/events/PastEvents";
import UpcomingEvents from "./pages/events/UpcomingEvents";

import HalalMeat from "./pages/religious/HalalMeat";
import Mosques from "./pages/religious/Mosques";
import Circumcision from "./pages/religious/Circumcision";
import Umrah from "./pages/religious/Umrah";
import SalahTimings from "./pages/religious/SalahTimings";
import MosqueFee from "./pages/religious/MosqueFee";


import EnglishSchools from "./pages/general/EnglishSchools";
import RegularEvents from "./pages/general/RegularEvents";
import FirstDay from "./pages/general/FirstDay";
import NROChecklist from "./pages/general/NROChecklist";
 

function App() {
  return (
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            
            <Route path="/" element={<Home />} />

            <Route path="contact" element={<Contact />} />

            <Route path="events">
              <Route path="past" element={<PastEvents />} />
              <Route path="upcoming" element={<UpcomingEvents />} />
            </Route>

            <Route path="religious">
              <Route path="mosques" element={<Mosques />} />
              <Route path="halalmeat" element={<HalalMeat />} />
              <Route path="circumcision" element={<Circumcision />} />
              <Route path="umrah" element={<Umrah />} />
              <Route path="salahtimings" element={<SalahTimings />} />
              <Route path="mosquefee" element={<MosqueFee />} />
            </Route>

            <Route path="general">
              <Route path="englishschools" element={<EnglishSchools />} />
              <Route path="regularevents" element={<RegularEvents />} />
              <Route path="firstday" element={<FirstDay />} />
              <Route path="nrochecklist" element={<NROChecklist />} />
            </Route>

            <Route path="board" element={<Board />} />

            <Route path="Photogallery" element={<PhotoGallery />} />  

            <Route path="blogs" element={<Blogs />} />

          </Route>
      </Routes>
    </Router>

  );

}

export default App;